var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgEmailContainer(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 502,
    height: 529,
    viewBox: "0 0 502 529",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_908_6675)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 502,
    height: 529,
    rx: 18,
    fill: "url(#paint0_linear_908_6675)",
    fillOpacity: 0.05
  }), /*#__PURE__*/React.createElement("rect", {
    x: 2.5,
    y: 2.5,
    width: 499,
    height: 449,
    rx: 15.5,
    stroke: "url(#paint1_linear_908_6675)",
    strokeOpacity: 0.08
  }), /*#__PURE__*/React.createElement("line", {
    x1: 202.5,
    y1: 2,
    x2: 202.5,
    y2: 529,
    stroke: "url(#paint2_linear_908_6675)",
    strokeOpacity: 0.08
  }), /*#__PURE__*/React.createElement("line", {
    x1: 203,
    y1: 95.5,
    x2: 502,
    y2: 95.5,
    stroke: "url(#paint3_linear_908_6675)",
    strokeOpacity: 0.08
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_908_6675",
    x1: 0,
    y1: 0,
    x2: 298.842,
    y2: 188.755,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6833FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_908_6675",
    x1: 179.209,
    y1: 2,
    x2: 359.298,
    y2: 161.646,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2F00B4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_908_6675",
    x1: 201.5,
    y1: 2,
    x2: 201.5,
    y2: 529,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2F00B4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#15004E",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_908_6675",
    x1: 203,
    y1: 96.5,
    x2: 502,
    y2: 96.5,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2F00B4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#15004E",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_908_6675"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 502,
    height: 529,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmailContainer);
export default __webpack_public_path__ + "static/media/email-container.cf61f78d3c43fe232758050bae284ae4.svg";
export { ForwardRef as ReactComponent };